import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=f06dae6e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=f06dae6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06dae6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f06dae6e')) {
      api.createRecord('f06dae6e', component.options)
    } else {
      api.reload('f06dae6e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=f06dae6e&scoped=true&", function () {
      api.rerender('f06dae6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28PNoMckAly2U/JS/teamMember.vue"
export default component.exports